import React from 'react';
import jwtDecode from 'jwt-decode';
import api from 'api';
import { Modal } from 'hyperdb-utils';
import { FILESTORE_URL, AVAILABLE_LANGUAGES } from '../../../../../config';
import PdfForm from './PdfForm';

class PdfInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadPdfSuccess) {
      this.props.api.emailPropertyData.setData({ uploadPdfSuccess: false });
      if (nextProps.savedPdf) {
        this.toggleModalForm(false);
        this.props.onChange({ name: this.props.name, value: nextProps.savedPdf });
      }
    }
    if (nextProps.deletePdfSuccess) {
      this.props.api.emailPropertyData.setData({ deletePdfSuccess: false });
      this.toggleModalDelete(false);
      this.props.onChange({ name: this.props.name, value: null });
    }
  }
  render() {
    const file = this.props.value;
    return (
      <fieldset>
        {
          !file || !file.value
            ? <div>
                No file &nbsp;<button type="button" className="btn btn-primary btn-xs" onClick={this.toggleModalForm.bind(this, true)}>Add</button>
              </div>
            : null
        }
        {
          file && file.value
            ? <div>
                <a href={ this.pdfUrl(file) } target="_blank">{ file.value.name }</a>
                &nbsp; <button type="button" className="btn btn-primary btn-xs" onClick={this.toggleModalForm.bind(this, true)}>Edit</button>
                &nbsp; <button type="button" className="btn btn-danger btn-xs" onClick={this.toggleModalDelete.bind(this, true)}>Delete</button>
              </div>
            : null
        }
        {
          this.props.showModalFormPdf
            ? <Modal title="" onClose={ this.toggleModalForm.bind(this, false) } onAccept={ this.handleUpload } loading={ this.props.uploadingPdf }>
                <PdfForm pdf={ this.props.editedPdf } onChange={ this.handleChange } uploading={ this.props.uploadingPdf } />
              </Modal>
            : null
        }
        {
          this.props.showModalDeletePdf
            ? <Modal title="" onClose={ this.toggleModalDelete.bind(this, false) } onAccept={ this.handleDelete } loading={ this.props.deletingPdf }>
                Delete this file ?
                <br/>
                { this.props.deletingPdf ? 'DELETING...' : '' }
              </Modal>
            : null
        }
      </fieldset>
    );
  }

  pdfUrl(file) {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    const propertyDataId = this.props.objectData.id;
    return `${FILESTORE_URL}/${decoded.client_id}/property-datas/${propertyDataId}/${file.value.id}`;
  }

  toggleModalForm(bool) {
    const editedPdf = bool ? { ...this.props.value || {} } : null;
    this.props.api.emailPropertyData.setData({ showModalFormPdf: bool, editedPdf });
  }
  handleChange({ filename, payload }) {
    const editedPdf = { ...this.props.editedPdf, payload };
    this.props.api.emailPropertyData.setData({ editedPdf });
  }
  handleUpload() {
    if (!this.props.editedPdf.payload) return this.toggleModalForm(false);
    const propertyDataId = this.props.objectData.id;
    const locale = this.props.locale || this.props.name;
    this.props.api.emailPropertyData.savePdf({ locale, propertyDataId, pdf: this.props.editedPdf });
  }
  toggleModalDelete(bool) {
    this.props.api.emailPropertyData.setData({ showModalDeletePdf: bool });
  }
  handleDelete() {
    const propertyDataId = this.props.objectData.id;
    const locale = this.props.locale || this.props.name;
    this.props.api.emailPropertyData.deletePdf({ locale, propertyDataId });
  }
}

export default api.connect(PdfInput, 'emailPropertyData');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/components/PdfInput.jsx